import React, { useEffect, useState } from "react";
import Seo from "../../../Components/SeoComponent/Seo";
import Header from "../../../Components/Header";
import { useService } from "../../../context/ServiceContext";
import {
  AlertCircle,
  ArrowRight,
  Cog,
  FileCheck,
  Gauge,
  Loader,
  ShieldCheck,
} from "lucide-react";
import { fetchProfile } from "../../../Services/ApiTestService/aadharTestService";
import { showErrorToast, showSuccessToast } from "../../../utils/toastUtils";
import { isAlphanumeric } from "validator";
import { checkTransUnionReportHybrid } from "../../../Services/EquifaxCScore/highmark";
import { getServiceNameAndDetails } from "../../../Services";
import SummaryScore from "./SummaryScore";

function TransunionHybrid() {
  const [isLoading, setIsLoading] = useState(false);
  const [response, setResponse] = useState({
    "status": {
        "code": 200,
        "type": "success",
        "message": "CIBIL report ready! Click the link to view your score."
    },

    "data": {
  "status": "success",
  "error_code": null,
  "message": "CIBIL report ready. The TransUnion link expires in ~15-30 minutes; reports.xaler_json_report is the stored copy that does not. Send \"generate_xaler_reports\": \"Y\" if you also want it as a PDF.",
  "what_to_do_next": null,
  "retryable": false,
  "diagnosis": {
    "code": "SUCCESS",
    "title": "Report generated",
    "message": "The credit report was generated successfully.",
    "next_step": null,
    "retryable": false,
    "failed_step": null,
    "bureau_message": null,
    "warnings": []
  },
  "skip_declined": null,
  "report_source": "live",
  "report_source_note": "Pulled live from TransUnion and archived by Xaler.",
  "report_summary": {
    "control_number": "11546884092",
    "report_date": "29/08/2026",
    "name": "BHALACHANDRA DEVIDAS PATIL",
    "date_of_birth": "01/08/1989",
    "gender": "Male",
    "pan": "CWKPP9496H",
    "credit_score": 651,
    "score_name": "CIBILTransUnionScore3",
    "score_band": "Fair",
    "total_accounts": 12,
    "open_accounts": 3,
    "closed_accounts": 9,
    "total_sanctioned_amount": 17458050,
    "total_current_balance": 4983104,
    "total_amount_overdue": 1456848,
    "total_enquiries": 7,
    "on_time_payment_history_pct": "62.82",
    "credit_card_utilization_pct": "0",
    "oldest_account_age_months": "106"
  },
  "recovered_report": null,
  "reports": {
    "transunion_live_report": {
      "url": "https://myscore.cibil.com/CreditView/webtokenasset.page?enterprise=UYFincorp&pcc=J92AQFLNIMWBG2HCBRBA&webtoken=6WyeN-Vuf3QwNTc8apPfaQCaOsOQE4QeRzijqzupOd453FGPerRdEFxOiS_4sq5J37XZ1XkFBjHucNYRijqDGCypXw5kWhssi356tUzjItU",
      "source": "TransUnion CIBIL (live)",
      "format": "web",
      "expires": "about 15-30 minutes after generation",
      "note": "Short-lived by TransUnion security policy and cannot be extended. Open it immediately; after it expires the page shows \"Access Expired\". Use the stored Xaler copy for anything you need to keep."
    },
    "xaler_json_report": {
      "url": "https://my-credit-analytics-bucket-xaler.s3.amazonaws.com/TransUnion-json/transunion_cibil_11546884092.json?AWSAccessKeyId=AKIA3FLD3UWVR3KVDQVK&Signature=eFyA61YawnjrlzRYztiOsURkDDQ%3D&Expires=1788586206",
      "source": "Xaler (stored copy of the bureau response)",
      "format": "json",
      "expires": "7 days (link); the stored file is retained longer",
      "note": "Always archived whenever the bureau returns a report — this is what remains once the TransUnion link expires."
    },
    "xaler_pdf_report": {
      "url": null,
      "source": "Xaler (rendered from the same bureau data)",
      "format": "pdf",
      "layout": null,
      "layout_name": null,
      "layouts_available": {
        "v1": "Xaler CIBIL report (original layout)",
        "v2": "Consumer CIR layout (A3, lender-facing)",
        "v3": "CIBIL Score & Report layout (A4, consumer-facing)"
      },
      "expires": "7 days (link); the stored file is retained longer",
      "note": "Not rendered for this call. Send \"generate_xaler_reports\": \"Y\" to have Xaler build the PDF as well as the JSON."
    },
    "xaler_copies_status": "generating",
    "xaler_copies_note": "The Xaler links are being generated and are usually ready within ~15 seconds. Retry the link if it 404s at first."
  },
  "client_key": "J92AQFLNIMWBG2HCBRBA",
  "identity_sent": {
    "forename": "BHALCHANDRA",
    "surname": "PATIL",
    "pan_id": "CWKPP9496H",
    "phone_number": "9921051761",
    "gender": "Male"
  },
  "match_strength": {
    "score": 65,
    "level": "weak",
    "present": [
      "PAN - the bureau's strongest single identifier",
      "forename and surname",
      "registered mobile"
    ],
    "missing": [
      "date of birth - separates same-name consumers",
      "PIN code"
    ],
    "advice": "This identity is below the level that matches reliably at CIBIL. The bureau scores name, date of birth, PAN and phone together, so a payload missing one of them can match one day and return NO_HIT the next. Add the missing fields listed in match_strength.missing before retrying."
  },
  "warnings": [],
  "pending_authentication": null,
  "steps_summary": [
    {
      "step": 1,
      "name": "FulfillOffer",
      "status": "success"
    },
    {
      "step": 2,
      "name": "GetAuthenticationQuestions",
      "status": "success"
    },
    {
      "step": 3,
      "name": "GetCustomerAssets",
      "status": "success"
    },
    {
      "step": 4,
      "name": "GetProductWebToken",
      "status": "success"
    }
  ],
  "steps": [
    {
      "step": 1,
      "name": "FulfillOffer",
      "status": "success",
      "http_code": 200,
      "response": {
        "FulfillOfferResponse": {
          "ResponseStatus": "Success",
          "ResponseKey": "7f205350fefe3b77:-1fe69dfe:1a04be73648:95b",
          "FulfillOfferSuccess": {
            "Status": "Pending"
          }
        }
      }
    },
    {
      "step": 2,
      "name": "GetAuthenticationQuestions",
      "status": "success",
      "http_code": 200,
      "response": {
        "GetAuthenticationQuestionsResponse": {
          "ResponseStatus": "Success",
          "ResponseKey": "d324dcbe9a4563b0:-2e67814f:1a04bfa8952:-563d",
          "GetAuthenticationQuestionsSuccess": {
            "ChallengeConfigGUID": "2323117661",
            "IVStatus": "Success"
          }
        }
      }
    },
    {
      "step": 3,
      "name": "GetCustomerAssets",
      "status": "success",
      "http_code": 200,
      "response": {
        "GetCustomerAssetsResponse": {
          "ResponseStatus": "Success",
          "ResponseKey": "c1297e79423a9be9:20160308:1a04bf0510f:-140",
          "GetCustomerAssetsSuccess": {
            "CreditSummaryData": {
              "OldestCreditAccountPeriod": "106",
              "Inquires": "7",
              "OnTimePaymentHistory": "62.82",
              "CreditCardUtilization": "0",
              "CreditMix": "66.67"
            },
            "Asset": {
              "Status": "Active",
              "SafetyCheckFailure": false,
              "ExpirationDate": "2028-08-28T11:00:03.687+05:30",
              "CreationDate": "2026-08-29T11:00:03.687+05:30",
              "TrueLinkCreditReport": {
                "ReferenceKey": "11546884092",
                "currentversion": "5.0",
                "Borrower": {
                  "Birth": {
                    "date": "1989-08-01+05:30",
                    "partitionSet": "0",
                    "BirthDate": {
                      "month": "8",
                      "year": "1989",
                      "day": "1"
                    },
                    "Source": {
                      "Reference": "f9aaa11a-8716-43e5-9774-83d951ad8d1e",
                      "InquiryDate": "2026-08-29+05:30",
                      "Locale": "en_IN",
                      "BorrowerKey": "1841954230",
                      "Bureau": {
                        "symbol": "CIBIL",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      }
                    },
                    "age": "0"
                  },
                  "borrowerKey": "1841954230",
                  "BorrowerAddress": [
                    {
                      "Dwelling": {
                        "symbol": "02",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "Ownership": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "addressOrder": "0",
                      "dateReported": "2021-12-31+05:30",
                      "partitionSet": "0",
                      "CreditAddress": {
                        "SerialNumber": "1516313388",
                        "AddressType": "",
                        "StreetAddress": "A/P BITARGAON TAL-MADHA SOLAPUR BITARGAON - NEAR VITTHAL MANDIR MAHARASHTRA 413252",
                        "City": "",
                        "PostalCode": "413252",
                        "Region": "27"
                      },
                      "Origin": {
                        "symbol": "KOTAK BANK",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "enrichMode": "R",
                      "Source": {
                        "Reference": "f9aaa11a-8716-43e5-9774-83d951ad8d1e",
                        "InquiryDate": "2026-08-29+05:30",
                        "Locale": "en_IN",
                        "BorrowerKey": "1841954230",
                        "Bureau": {
                          "symbol": "CIBIL",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        }
                      }
                    },
                    {
                      "Dwelling": {
                        "symbol": "04",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "Ownership": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "addressOrder": "1",
                      "dateReported": "2004-09-30+05:30",
                      "partitionSet": "1",
                      "CreditAddress": {
                        "SerialNumber": "19375402",
                        "AddressType": "",
                        "StreetAddress": "A/P.BITARGAON TAL-MADHA.SOLAPUR BIT N - NEAR VITTHAL L-MADHA.SOLAPUR BITARGAON - NEAR VI KURUDWADI",
                        "City": "",
                        "PostalCode": "413252",
                        "Region": "27"
                      },
                      "Origin": {
                        "symbol": "BOI",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "enrichMode": "R",
                      "Source": {
                        "Reference": "f9aaa11a-8716-43e5-9774-83d951ad8d1e",
                        "InquiryDate": "2026-08-29+05:30",
                        "Locale": "en_IN",
                        "BorrowerKey": "1841954230",
                        "Bureau": {
                          "symbol": "CIBIL",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        }
                      }
                    }
                  ],
                  "CreditScore": {
                    "CreditScoreModel": {
                      "symbol": "CIBILTUSC3",
                      "description": "",
                      "rank": "100000",
                      "abbreviation": ""
                    },
                    "CreditScoreFactor": [
                      {
                        "bureauCode": "07",
                        "Factor": {
                          "symbol": "07",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "FactorText": [
                          "explain: One of the factors your CIBIL Score depends on is the timely payments you make towards your outstanding loans and credit cards. If you have missed a payment in the last 36 months, it will lead to your account being delinquent. Any delinquency will have a negative impact on your CIBIL Score. One way to improve your CIBIL Score is to make your payments before/by the due date. This will prevent your account from getting delinquent and will subsequently have a positive impact on your CIBIL Score.",
                          "factor: One of the factors your CIBIL Score depends on is the timely payments you make towards your outstanding loans and credit cards. If you have missed a payment in the last 36 months, it will lead to your account being delinquent. Any delinquency will have a negative impact on your CIBIL Score. One way to improve your CIBIL Score is to make your payments before/by the due date. This will prevent your account from getting delinquent and will subsequently have a positive impact on your CIBIL Score."
                        ]
                      },
                      {
                        "bureauCode": "03",
                        "Factor": {
                          "symbol": "03",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "FactorText": [
                          "explain: One of the factors your CIBIL Score depends on is the timely payments you make towards your outstanding loans and credit cards. If you have missed a payment in the last 36 months, it will lead to your account being delinquent. Any delinquency will have a negative impact on your CIBIL Score. One way to improve your CIBIL Score is to make your payments before/by the due date. This will prevent your account from getting delinquent and will subsequently have a positive impact on your CIBIL Score.",
                          "factor: One of the factors your CIBIL Score depends on is the timely payments you make towards your outstanding loans and credit cards. If you have missed a payment in the last 36 months, it will lead to your account being delinquent. Any delinquency will have a negative impact on your CIBIL Score. One way to improve your CIBIL Score is to make your payments before/by the due date. This will prevent your account from getting delinquent and will subsequently have a positive impact on your CIBIL Score."
                        ]
                      },
                      {
                        "bureauCode": "08",
                        "Factor": {
                          "symbol": "08",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "FactorText": [
                          "explain: One of the factors your CIBIL Score depends on is the timely payments you make towards your outstanding loans and credit cards. If you have missed a payment for more than 91 days in the last 36 months, your account will be tagged as severely delinquent. Any severe delinquency will have a negative impact on your CIBIL Score even further. One way to improve your CIBIL Score is to make your payments before/by the due date. This will prevent your account from getting delinquent and will subsequently have a positive impact on your CIBIL Score.",
                          "factor: One of the factors your CIBIL Score depends on is the timely payments you make towards your outstanding loans and credit cards. If you have missed a payment for more than 91 days in the last 36 months, your account will be tagged as severely delinquent. Any severe delinquency will have a negative impact on your CIBIL Score even further. One way to improve your CIBIL Score is to make your payments before/by the due date. This will prevent your account from getting delinquent and will subsequently have a positive impact on your CIBIL Score."
                        ]
                      },
                      {
                        "bureauCode": "04",
                        "Factor": {
                          "symbol": "04",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "FactorText": [
                          "explain: One of the factors your CIBIL Score depends on is the timely payments you make towards your outstanding loans and credit cards. If the percentage of credit card and loan accounts for which payments have been made on time, is high, your CIBIL Score will be impacted positively. To maintain a good CIBIL Score, ensure your payments are made by the due date for each of the loans or credit facilities that you have availed. Timely payments will impact your score positively.",
                          "factor: One of the factors your CIBIL Score depends on is the timely payments you make towards your outstanding loans and credit cards. If the percentage of credit card and loan accounts for which payments have been made on time, is high, your CIBIL Score will be impacted positively. To maintain a good CIBIL Score, ensure your payments are made by the due date for each of the loans or credit facilities that you have availed. Timely payments will impact your score positively."
                        ]
                      },
                      {
                        "bureauCode": "00",
                        "Factor": {
                          "symbol": "00",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "FactorText": [
                          "No Valid Factors",
                          "We're sorry, but the adverse factors affecting your Credit Score are currently unavailable. Factors that may affect your score include: payment history, outstanding debt, credit account history, recent inquiries, types of credit and other features such as bankruptcies and collection accounts."
                        ]
                      }
                    ],
                    "NoScoreReason": {
                      "symbol": "",
                      "description": "",
                      "rank": "100000",
                      "abbreviation": ""
                    },
                    "riskScore": "651",
                    "populationRank": "25",
                    "Source": {
                      "Reference": "f9aaa11a-8716-43e5-9774-83d951ad8d1e",
                      "InquiryDate": "2026-08-29+05:30",
                      "Locale": "en_IN",
                      "BorrowerKey": "1841954230",
                      "Bureau": {
                        "symbol": "CIBIL",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      }
                    },
                    "scoreName": "CIBILTransUnionScore3"
                  },
                  "Employer": {
                    "serialNumber": "4190524913",
                    "IncomeFreqIndicator": "",
                    "NetGrossIndicator": "",
                    "dateReported": "2026-08-23+05:30",
                    "name": "",
                    "OccupationCode": {
                      "symbol": "04",
                      "description": "Others",
                      "rank": "100000",
                      "abbreviation": ""
                    },
                    "partitionSet": "0",
                    "CreditAddress": {
                      "AddressType": "",
                      "StreetAddress": "",
                      "City": "",
                      "PostalCode": "",
                      "Region": ""
                    },
                    "Source": {
                      "Reference": "f9aaa11a-8716-43e5-9774-83d951ad8d1e",
                      "InquiryDate": "2026-08-29+05:30",
                      "Locale": "en_IN",
                      "BorrowerKey": "1841954230",
                      "Bureau": {
                        "symbol": "CIBIL",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      }
                    },
                    "account": "03"
                  },
                  "Gender": "Male",
                  "CreditStatement": {
                    "StatementType": {
                      "symbol": "DISPUTE",
                      "description": "",
                      "rank": "100000",
                      "abbreviation": ""
                    },
                    "statement": "",
                    "Source": {
                      "Reference": "f9aaa11a-8716-43e5-9774-83d951ad8d1e",
                      "InquiryDate": "2026-08-29+05:30",
                      "Locale": "en_IN",
                      "BorrowerKey": "1841954230",
                      "Bureau": {
                        "symbol": "CIBIL",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      }
                    },
                    "dateUpdated": ""
                  },
                  "EmailAddress": {
                    "serialNumber": "190621061",
                    "Email": "NA@NA.NA"
                  },
                  "IdentifierPartition": {
                    "Identifier": [
                      {
                        "ID": {
                          "Id": "1841954230",
                          "IdentifierName": "SocialId"
                        },
                        "Source": {
                          "Reference": "f9aaa11a-8716-43e5-9774-83d951ad8d1e",
                          "InquiryDate": "2026-08-29+05:30",
                          "Locale": "en_IN",
                          "BorrowerKey": "1841954230",
                          "Bureau": {
                            "symbol": "CIBIL",
                            "description": "",
                            "rank": "100000",
                            "abbreviation": ""
                          }
                        }
                      },
                      {
                        "ID": {
                          "SerialNumber": "529650726",
                          "Id": "CWKPP9496H",
                          "IdentifierName": "TaxId"
                        },
                        "enrichMode": "R",
                        "Source": {
                          "Reference": "f9aaa11a-8716-43e5-9774-83d951ad8d1e",
                          "InquiryDate": "2026-08-29+05:30",
                          "Locale": "en_IN",
                          "BorrowerKey": "1841954230",
                          "Bureau": {
                            "symbol": "CIBIL",
                            "description": "",
                            "rank": "100000",
                            "abbreviation": ""
                          }
                        }
                      },
                      {
                        "ID": {
                          "SerialNumber": "983251901",
                          "Id": "30004239592920",
                          "IdentifierName": "CkycId"
                        },
                        "enrichMode": "R",
                        "Source": {
                          "Reference": "f9aaa11a-8716-43e5-9774-83d951ad8d1e",
                          "InquiryDate": "2026-08-29+05:30",
                          "Locale": "en_IN",
                          "BorrowerKey": "1841954230",
                          "Bureau": {
                            "symbol": "CIBIL",
                            "description": "",
                            "rank": "100000",
                            "abbreviation": ""
                          }
                        }
                      }
                    ]
                  },
                  "BorrowerName": {
                    "Name": {
                      "Forename": "BHALACHANDRA DEVIDAS PATIL"
                    },
                    "partitionSet": "0",
                    "NameType": {
                      "symbol": "",
                      "description": "",
                      "rank": "100000",
                      "abbreviation": ""
                    },
                    "Source": {
                      "Reference": "f9aaa11a-8716-43e5-9774-83d951ad8d1e",
                      "InquiryDate": "2026-08-29+05:30",
                      "Locale": "en_IN",
                      "BorrowerKey": "1841954230",
                      "Bureau": {
                        "symbol": "CIBIL",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      }
                    }
                  },
                  "BorrowerTelephone": [
                    {
                      "partitionSet": "0",
                      "PhoneNumber": {
                        "SerialNumber": "1030984069",
                        "Number": "9921051761"
                      },
                      "enrichMode": "R",
                      "Source": {
                        "Reference": "f9aaa11a-8716-43e5-9774-83d951ad8d1e",
                        "InquiryDate": "2026-08-29+05:30",
                        "Locale": "en_IN",
                        "BorrowerKey": "1841954230",
                        "Bureau": {
                          "symbol": "CIBIL",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        }
                      },
                      "PhoneType": {
                        "symbol": "01",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      }
                    },
                    {
                      "partitionSet": "1",
                      "PhoneNumber": {
                        "SerialNumber": "1025519104",
                        "Number": "919921051761"
                      },
                      "enrichMode": "R",
                      "Source": {
                        "Reference": "f9aaa11a-8716-43e5-9774-83d951ad8d1e",
                        "InquiryDate": "2026-08-29+05:30",
                        "Locale": "en_IN",
                        "BorrowerKey": "1841954230",
                        "Bureau": {
                          "symbol": "CIBIL",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        }
                      },
                      "PhoneType": {
                        "symbol": "03",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      }
                    },
                    {
                      "partitionSet": "2",
                      "PhoneNumber": {
                        "SerialNumber": "968585382",
                        "Number": "+919921051761"
                      },
                      "enrichMode": "R",
                      "Source": {
                        "Reference": "f9aaa11a-8716-43e5-9774-83d951ad8d1e",
                        "InquiryDate": "2026-08-29+05:30",
                        "Locale": "en_IN",
                        "BorrowerKey": "1841954230",
                        "Bureau": {
                          "symbol": "CIBIL",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        }
                      },
                      "PhoneType": {
                        "symbol": "00",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      }
                    },
                    {
                      "partitionSet": "3",
                      "PhoneNumber": {
                        "SerialNumber": "1729524694",
                        "Number": "917385937000"
                      },
                      "enrichMode": "R",
                      "Source": {
                        "Reference": "f9aaa11a-8716-43e5-9774-83d951ad8d1e",
                        "InquiryDate": "2026-08-29+05:30",
                        "Locale": "en_IN",
                        "BorrowerKey": "1841954230",
                        "Bureau": {
                          "symbol": "CIBIL",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        }
                      },
                      "PhoneType": {
                        "symbol": "01",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      }
                    }
                  ]
                },
                "SafetyCheckPassed": true,
                "Frozen": "",
                "Message": {
                  "Code": {
                    "symbol": "",
                    "description": "",
                    "rank": "100000",
                    "abbreviation": ""
                  },
                  "text": "",
                  "Type": {
                    "symbol": "ZZ",
                    "description": "",
                    "rank": "100000",
                    "abbreviation": ""
                  }
                },
                "Sources": {
                  "Source": {
                    "InquiryDate": "2026-08-29T11:00:03.000+05:30",
                    "Bureau": {
                      "symbol": "CIBIL",
                      "description": "",
                      "rank": "100000",
                      "abbreviation": ""
                    },
                    "OriginalData": "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"
                  }
                },
                "DeceasedIndicator": false,
                "FraudIndicator": false,
                "TradeLinePartition": [
                  {
                    "accountTypeAbbreviation": "",
                    "accountTypeDescription": "",
                    "accountTypeSymbol": "34",
                    "Tradeline": {
                      "DisputeFlag": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "creditorName": "KOTAK BANK",
                      "branch": "",
                      "highBalance": "496995",
                      "dateOpened": "2021-11-22+05:30",
                      "dateReported": "2026-08-23+05:30",
                      "accountsSoldTo": "",
                      "bureau": "",
                      "writtenOffAmtTotal": "-1",
                      "PayStatus": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "currentBalance": "287547",
                      "subscriberCode": "3300001",
                      "AccountDesignator": {
                        "symbol": "1",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "dateAccountStatus": "2025-11-21+05:30",
                      "accountNumber": "TFE10755666",
                      "AccountCondition": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "Source": {
                        "Reference": "f9aaa11a-8716-43e5-9774-83d951ad8d1e",
                        "InquiryDate": "2026-08-29+05:30",
                        "Locale": "en_IN",
                        "BorrowerKey": "1841954230",
                        "Bureau": {
                          "symbol": "CIBIL",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        }
                      },
                      "IndustryCode": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "thirdPartyName": "",
                      "GrantedTrade": {
                        "interestRate": "-1.00",
                        "PaymentFrequency": {
                          "symbol": "",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "serialNumber": "1883130850",
                        "PayStatusHistory": {
                          "endDate": "2023-09-01+05:30",
                          "startDate": "2026-08-01+05:30",
                          "MonthlyPayStatus": [
                            {
                              "date": "2026-08-01+05:30",
                              "status": "445"
                            },
                            {
                              "date": "2026-07-01+05:30",
                              "status": "422"
                            },
                            {
                              "date": "2026-06-01+05:30",
                              "status": "391"
                            },
                            {
                              "date": "2026-05-01+05:30",
                              "status": "361"
                            },
                            {
                              "date": "2026-04-01+05:30",
                              "status": "330"
                            },
                            {
                              "date": "2026-03-01+05:30",
                              "status": "300"
                            },
                            {
                              "date": "2026-02-01+05:30",
                              "status": "269"
                            },
                            {
                              "date": "2026-01-01+05:30",
                              "status": "241"
                            },
                            {
                              "date": "2025-12-01+05:30",
                              "status": "210"
                            },
                            {
                              "date": "2025-11-01+05:30",
                              "status": "179"
                            },
                            {
                              "date": "2025-10-01+05:30",
                              "status": "331"
                            },
                            {
                              "date": "2025-09-01+05:30",
                              "status": "300"
                            },
                            {
                              "date": "2025-08-01+05:30",
                              "status": "270"
                            },
                            {
                              "date": "2025-07-01+05:30",
                              "status": "239"
                            },
                            {
                              "date": "2025-06-01+05:30",
                              "status": "208"
                            },
                            {
                              "date": "2025-05-01+05:30",
                              "status": "178"
                            },
                            {
                              "date": "2025-04-01+05:30",
                              "status": "147"
                            },
                            {
                              "date": "2025-03-01+05:30",
                              "status": "117"
                            },
                            {
                              "date": "2025-02-01+05:30",
                              "status": "86"
                            },
                            {
                              "date": "2025-01-01+05:30",
                              "status": "58"
                            },
                            {
                              "date": "2024-12-01+05:30",
                              "status": "27"
                            },
                            {
                              "date": "2024-11-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-10-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-09-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-08-01+05:30",
                              "status": "88"
                            },
                            {
                              "date": "2024-07-01+05:30",
                              "status": "57"
                            },
                            {
                              "date": "2024-06-01+05:30",
                              "status": "26"
                            },
                            {
                              "date": "2024-05-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-04-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-03-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-02-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-01-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2023-12-01+05:30",
                              "status": "27"
                            },
                            {
                              "date": "2023-11-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2023-10-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2023-09-01+05:30",
                              "status": "0"
                            }
                          ],
                          "status": "445,422,391,361,330,300,269,241,210,179,331,300,270,239,208,178,147,117,86,58,27,0,0,0,88,57,26,0,0,0,0,0,27,0,0,0,"
                        },
                        "EMIAmount": "69800",
                        "WorstPayStatus": {
                          "symbol": "",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "CashLimit": "-1",
                        "dateLastPayment": "2025-11-21+05:30",
                        "AccountType": {
                          "symbol": "34",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "CreditType": {
                          "symbol": "34",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "actualPaymentAmount": "-1",
                        "termMonths": "60",
                        "CreditLimit": "-1",
                        "CollateralType": {
                          "symbol": "",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "amountPastDue": "222070",
                        "collateral": "-1",
                        "TermType": {
                          "symbol": "",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        }
                      },
                      "VerificationIndicator": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "noOfParticipants": "",
                      "OpenClosed": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "position": "0",
                      "settlementAmount": "-1",
                      "writtenOffPrincipal": "-1"
                    }
                  },
                  {
                    "accountTypeAbbreviation": "",
                    "accountTypeDescription": "",
                    "accountTypeSymbol": "03",
                    "Tradeline": {
                      "DisputeFlag": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "creditorName": "VIDYABANK",
                      "branch": "",
                      "highBalance": "5000000",
                      "dateOpened": "2026-03-31+05:30",
                      "dateReported": "2026-08-23+05:30",
                      "accountsSoldTo": "",
                      "bureau": "",
                      "writtenOffAmtTotal": "-1",
                      "PayStatus": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "currentBalance": "4671677",
                      "subscriberCode": "19470001",
                      "AccountDesignator": {
                        "symbol": "1",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "dateAccountStatus": "2026-06-11+05:30",
                      "accountNumber": "000112220000047",
                      "AccountCondition": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "Source": {
                        "Reference": "f9aaa11a-8716-43e5-9774-83d951ad8d1e",
                        "InquiryDate": "2026-08-29+05:30",
                        "Locale": "en_IN",
                        "BorrowerKey": "1841954230",
                        "Bureau": {
                          "symbol": "CIBIL",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        }
                      },
                      "IndustryCode": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "thirdPartyName": "",
                      "GrantedTrade": {
                        "interestRate": "15.00",
                        "PaymentFrequency": {
                          "symbol": "03",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "serialNumber": "4190524913",
                        "PayStatusHistory": {
                          "endDate": "2026-03-01+05:30",
                          "startDate": "2026-08-01+05:30",
                          "MonthlyPayStatus": [
                            {
                              "date": "2026-08-01+05:30",
                              "status": "86"
                            },
                            {
                              "date": "2026-07-01+05:30",
                              "status": "63"
                            },
                            {
                              "date": "2026-06-01+05:30",
                              "status": "32"
                            },
                            {
                              "date": "2026-05-01+05:30",
                              "status": "32"
                            },
                            {
                              "date": "2026-04-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2026-03-01+05:30",
                              "status": "0"
                            }
                          ],
                          "status": "86,63,32,32,0,0,"
                        },
                        "EMIAmount": "451292",
                        "WorstPayStatus": {
                          "symbol": "",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "CashLimit": "-1",
                        "dateLastPayment": "2026-06-11+05:30",
                        "AccountType": {
                          "symbol": "03",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "CreditType": {
                          "symbol": "03",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "actualPaymentAmount": "-1",
                        "termMonths": "12",
                        "CreditLimit": "-1",
                        "CollateralType": {
                          "symbol": "00",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "amountPastDue": "1234778",
                        "collateral": "-1",
                        "TermType": {
                          "symbol": "",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        }
                      },
                      "VerificationIndicator": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "noOfParticipants": "",
                      "OpenClosed": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "position": "1",
                      "settlementAmount": "-1",
                      "writtenOffPrincipal": "-1"
                    }
                  },
                  {
                    "accountTypeAbbreviation": "",
                    "accountTypeDescription": "",
                    "accountTypeSymbol": "03",
                    "Tradeline": {
                      "DisputeFlag": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "creditorName": "VIDYABANK",
                      "dateClosed": "2026-03-31+05:30",
                      "branch": "",
                      "highBalance": "6000000",
                      "dateOpened": "2025-03-29+05:30",
                      "dateReported": "2026-03-31+05:30",
                      "accountsSoldTo": "",
                      "bureau": "",
                      "writtenOffAmtTotal": "-1",
                      "PayStatus": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "currentBalance": "0",
                      "subscriberCode": "19470001",
                      "AccountDesignator": {
                        "symbol": "4",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "dateAccountStatus": "2026-03-31+05:30",
                      "accountNumber": "000112220000023",
                      "AccountCondition": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "Source": {
                        "Reference": "f9aaa11a-8716-43e5-9774-83d951ad8d1e",
                        "InquiryDate": "2026-08-29+05:30",
                        "Locale": "en_IN",
                        "BorrowerKey": "1841954230",
                        "Bureau": {
                          "symbol": "CIBIL",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        }
                      },
                      "IndustryCode": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "thirdPartyName": "",
                      "GrantedTrade": {
                        "interestRate": "15.00",
                        "PaymentFrequency": {
                          "symbol": "03",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "serialNumber": "3951160352",
                        "PayStatusHistory": {
                          "endDate": "2025-10-01+05:30",
                          "startDate": "2026-03-01+05:30",
                          "MonthlyPayStatus": [
                            {
                              "date": "2026-03-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2026-02-01+05:30",
                              "status": "81"
                            },
                            {
                              "date": "2026-01-01+05:30",
                              "status": "83"
                            },
                            {
                              "date": "2025-12-01+05:30",
                              "status": "52"
                            },
                            {
                              "date": "2025-11-01+05:30",
                              "status": "1"
                            },
                            {
                              "date": "2025-10-01+05:30",
                              "status": "128"
                            }
                          ],
                          "status": "0,81,83,52,1,128,"
                        },
                        "EMIAmount": "541550",
                        "WorstPayStatus": {
                          "symbol": "",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "CashLimit": "-1",
                        "dateLastPayment": "2026-03-31+05:30",
                        "AccountType": {
                          "symbol": "03",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "CreditType": {
                          "symbol": "03",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "actualPaymentAmount": "-1",
                        "termMonths": "12",
                        "CreditLimit": "-1",
                        "CollateralType": {
                          "symbol": "",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "amountPastDue": "0",
                        "collateral": "-1",
                        "TermType": {
                          "symbol": "",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        }
                      },
                      "VerificationIndicator": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "noOfParticipants": "",
                      "OpenClosed": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "position": "2",
                      "settlementAmount": "-1",
                      "writtenOffPrincipal": "-1"
                    }
                  },
                  {
                    "accountTypeAbbreviation": "",
                    "accountTypeDescription": "",
                    "accountTypeSymbol": "06",
                    "Tradeline": {
                      "DisputeFlag": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "creditorName": "BAJAJ FIN LTD",
                      "dateClosed": "2024-10-07+05:30",
                      "branch": "",
                      "highBalance": "11999",
                      "dateOpened": "2024-03-30+05:30",
                      "dateReported": "2024-12-15+05:30",
                      "accountsSoldTo": "",
                      "bureau": "",
                      "writtenOffAmtTotal": "-1",
                      "PayStatus": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "currentBalance": "0",
                      "subscriberCode": "66030001",
                      "AccountDesignator": {
                        "symbol": "1",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "dateAccountStatus": "2024-10-02+05:30",
                      "accountNumber": "4O7RDDKZ282053",
                      "AccountCondition": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "Source": {
                        "Reference": "f9aaa11a-8716-43e5-9774-83d951ad8d1e",
                        "InquiryDate": "2026-08-29+05:30",
                        "Locale": "en_IN",
                        "BorrowerKey": "1841954230",
                        "Bureau": {
                          "symbol": "CIBIL",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        }
                      },
                      "IndustryCode": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "thirdPartyName": "",
                      "GrantedTrade": {
                        "interestRate": "-1.00",
                        "PaymentFrequency": {
                          "symbol": "03",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "serialNumber": "2974250868",
                        "PayStatusHistory": {
                          "endDate": "2024-03-01+05:30",
                          "startDate": "2024-12-01+05:30",
                          "MonthlyPayStatus": [
                            {
                              "date": "2024-12-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-11-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-10-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-09-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-08-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-07-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-06-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-05-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-04-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-03-01+05:30",
                              "status": "0"
                            }
                          ],
                          "status": "0,0,0,0,0,0,0,0,0,0,"
                        },
                        "EMIAmount": "1500",
                        "WorstPayStatus": {
                          "symbol": "",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "CashLimit": "-1",
                        "dateLastPayment": "2024-10-02+05:30",
                        "AccountType": {
                          "symbol": "06",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "CreditType": {
                          "symbol": "06",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "actualPaymentAmount": "-1",
                        "termMonths": "8",
                        "CreditLimit": "-1",
                        "CollateralType": {
                          "symbol": "",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "amountPastDue": "0",
                        "collateral": "-1",
                        "TermType": {
                          "symbol": "",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        }
                      },
                      "VerificationIndicator": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "noOfParticipants": "",
                      "OpenClosed": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "position": "3",
                      "settlementAmount": "-1",
                      "writtenOffPrincipal": "-1"
                    }
                  },
                  {
                    "accountTypeAbbreviation": "",
                    "accountTypeDescription": "",
                    "accountTypeSymbol": "06",
                    "Tradeline": {
                      "DisputeFlag": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "creditorName": "BAJAJ FIN LTD",
                      "dateClosed": "2024-09-07+05:30",
                      "branch": "",
                      "highBalance": "32999",
                      "dateOpened": "2024-01-19+05:30",
                      "dateReported": "2024-10-31+05:30",
                      "accountsSoldTo": "",
                      "bureau": "",
                      "writtenOffAmtTotal": "-1",
                      "PayStatus": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "currentBalance": "0",
                      "subscriberCode": "66030001",
                      "AccountDesignator": {
                        "symbol": "1",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "dateAccountStatus": "2024-08-02+05:30",
                      "accountNumber": "4O7RDDKS267851",
                      "AccountCondition": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "Source": {
                        "Reference": "f9aaa11a-8716-43e5-9774-83d951ad8d1e",
                        "InquiryDate": "2026-08-29+05:30",
                        "Locale": "en_IN",
                        "BorrowerKey": "1841954230",
                        "Bureau": {
                          "symbol": "CIBIL",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        }
                      },
                      "IndustryCode": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "thirdPartyName": "",
                      "GrantedTrade": {
                        "interestRate": "-1.00",
                        "PaymentFrequency": {
                          "symbol": "03",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "serialNumber": "2836280499",
                        "PayStatusHistory": {
                          "endDate": "2024-01-01+05:30",
                          "startDate": "2024-10-01+05:30",
                          "MonthlyPayStatus": [
                            {
                              "date": "2024-10-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-09-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-08-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-07-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-06-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-05-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-04-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-03-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-02-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-01-01+05:30",
                              "status": "0"
                            }
                          ],
                          "status": "0,0,0,0,0,0,0,0,0,0,"
                        },
                        "EMIAmount": "4125",
                        "WorstPayStatus": {
                          "symbol": "",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "CashLimit": "-1",
                        "dateLastPayment": "2024-08-02+05:30",
                        "AccountType": {
                          "symbol": "06",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "CreditType": {
                          "symbol": "06",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "actualPaymentAmount": "-1",
                        "termMonths": "8",
                        "CreditLimit": "-1",
                        "CollateralType": {
                          "symbol": "",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "amountPastDue": "0",
                        "collateral": "-1",
                        "TermType": {
                          "symbol": "",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        }
                      },
                      "VerificationIndicator": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "noOfParticipants": "",
                      "OpenClosed": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "position": "4",
                      "settlementAmount": "-1",
                      "writtenOffPrincipal": "-1"
                    }
                  },
                  {
                    "accountTypeAbbreviation": "",
                    "accountTypeDescription": "",
                    "accountTypeSymbol": "03",
                    "Tradeline": {
                      "DisputeFlag": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "creditorName": "VIDYABANK",
                      "dateClosed": "2025-07-31+05:30",
                      "branch": "",
                      "highBalance": "5000000",
                      "dateOpened": "2023-10-19+05:30",
                      "dateReported": "2025-08-15+05:30",
                      "accountsSoldTo": "",
                      "bureau": "",
                      "writtenOffAmtTotal": "-1",
                      "PayStatus": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "currentBalance": "0",
                      "subscriberCode": "19470001",
                      "AccountDesignator": {
                        "symbol": "1",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "dateAccountStatus": "2025-07-31+05:30",
                      "accountNumber": "6020011218009766",
                      "AccountCondition": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "Source": {
                        "Reference": "f9aaa11a-8716-43e5-9774-83d951ad8d1e",
                        "InquiryDate": "2026-08-29+05:30",
                        "Locale": "en_IN",
                        "BorrowerKey": "1841954230",
                        "Bureau": {
                          "symbol": "CIBIL",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        }
                      },
                      "IndustryCode": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "thirdPartyName": "",
                      "GrantedTrade": {
                        "interestRate": "13.00",
                        "PaymentFrequency": {
                          "symbol": "03",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "serialNumber": "2726402091",
                        "PayStatusHistory": {
                          "endDate": "2023-10-01+05:30",
                          "startDate": "2025-08-01+05:30",
                          "MonthlyPayStatus": [
                            {
                              "date": "2025-08-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2025-07-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2025-06-01+05:30",
                              "status": "223"
                            },
                            {
                              "date": "2025-05-01+05:30",
                              "status": "193"
                            },
                            {
                              "date": "2025-04-01+05:30",
                              "status": "162"
                            },
                            {
                              "date": "2025-03-01+05:30",
                              "status": "132"
                            },
                            {
                              "date": "2025-02-01+05:30",
                              "status": "101"
                            },
                            {
                              "date": "2025-01-01+05:30",
                              "status": "73"
                            },
                            {
                              "date": "2024-12-01+05:30",
                              "status": "42"
                            },
                            {
                              "date": "2024-11-01+05:30",
                              "status": "11"
                            },
                            {
                              "date": "2024-10-01+05:30",
                              "status": "1"
                            },
                            {
                              "date": "2024-09-01+05:30",
                              "status": "103"
                            },
                            {
                              "date": "2024-08-01+05:30",
                              "status": "73"
                            },
                            {
                              "date": "2024-07-01+05:30",
                              "status": "103"
                            },
                            {
                              "date": "2024-06-01+05:30",
                              "status": "72"
                            },
                            {
                              "date": "2024-05-01+05:30",
                              "status": "42"
                            },
                            {
                              "date": "2024-04-01+05:30",
                              "status": "11"
                            },
                            {
                              "date": "2024-03-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-02-01+05:30",
                              "status": "72"
                            },
                            {
                              "date": "2024-01-01+05:30",
                              "status": "43"
                            },
                            {
                              "date": "2023-12-01+05:30",
                              "status": "12"
                            },
                            {
                              "date": "2023-11-01+05:30",
                              "status": "1"
                            },
                            {
                              "date": "2023-10-01+05:30",
                              "status": "0"
                            }
                          ],
                          "status": "0,0,223,193,162,132,101,73,42,11,1,103,73,103,72,42,11,0,72,43,12,1,0,"
                        },
                        "EMIAmount": "446586",
                        "WorstPayStatus": {
                          "symbol": "",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "CashLimit": "-1",
                        "dateLastPayment": "2025-07-31+05:30",
                        "AccountType": {
                          "symbol": "03",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "CreditType": {
                          "symbol": "03",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "actualPaymentAmount": "-1",
                        "termMonths": "12",
                        "CreditLimit": "-1",
                        "CollateralType": {
                          "symbol": "",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "amountPastDue": "0",
                        "collateral": "-1",
                        "TermType": {
                          "symbol": "",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        }
                      },
                      "VerificationIndicator": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "noOfParticipants": "",
                      "OpenClosed": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "position": "5",
                      "settlementAmount": "-1",
                      "writtenOffPrincipal": "-1"
                    }
                  },
                  {
                    "accountTypeAbbreviation": "",
                    "accountTypeDescription": "",
                    "accountTypeSymbol": "06",
                    "Tradeline": {
                      "DisputeFlag": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "creditorName": "BAJAJ FIN LTD",
                      "dateClosed": "2023-10-12+05:30",
                      "branch": "",
                      "highBalance": "19999",
                      "dateOpened": "2023-02-14+05:30",
                      "dateReported": "2023-11-30+05:30",
                      "accountsSoldTo": "",
                      "bureau": "",
                      "writtenOffAmtTotal": "-1",
                      "PayStatus": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "currentBalance": "0",
                      "subscriberCode": "66030001",
                      "AccountDesignator": {
                        "symbol": "1",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "dateAccountStatus": "2023-09-02+05:30",
                      "accountNumber": "4O7RDDJE832785",
                      "AccountCondition": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "Source": {
                        "Reference": "f9aaa11a-8716-43e5-9774-83d951ad8d1e",
                        "InquiryDate": "2026-08-29+05:30",
                        "Locale": "en_IN",
                        "BorrowerKey": "1841954230",
                        "Bureau": {
                          "symbol": "CIBIL",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        }
                      },
                      "IndustryCode": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "thirdPartyName": "",
                      "GrantedTrade": {
                        "interestRate": "-1.00",
                        "PaymentFrequency": {
                          "symbol": "03",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "serialNumber": "2417094284",
                        "PayStatusHistory": {
                          "endDate": "2023-02-01+05:30",
                          "startDate": "2023-11-01+05:30",
                          "MonthlyPayStatus": [
                            {
                              "date": "2023-11-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2023-10-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2023-09-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2023-08-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2023-07-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2023-06-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2023-05-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2023-04-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2023-03-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2023-02-01+05:30",
                              "status": "0"
                            }
                          ],
                          "status": "0,0,0,0,0,0,0,0,0,0,"
                        },
                        "EMIAmount": "2500",
                        "WorstPayStatus": {
                          "symbol": "",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "CashLimit": "-1",
                        "dateLastPayment": "2023-09-02+05:30",
                        "AccountType": {
                          "symbol": "06",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "CreditType": {
                          "symbol": "06",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "actualPaymentAmount": "-1",
                        "termMonths": "8",
                        "CreditLimit": "-1",
                        "CollateralType": {
                          "symbol": "",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "amountPastDue": "0",
                        "collateral": "-1",
                        "TermType": {
                          "symbol": "",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        }
                      },
                      "VerificationIndicator": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "noOfParticipants": "",
                      "OpenClosed": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "position": "6",
                      "settlementAmount": "-1",
                      "writtenOffPrincipal": "-1"
                    }
                  },
                  {
                    "accountTypeAbbreviation": "",
                    "accountTypeDescription": "",
                    "accountTypeSymbol": "06",
                    "Tradeline": {
                      "DisputeFlag": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "creditorName": "BAJAJ FIN LTD",
                      "dateClosed": "2023-09-03+05:30",
                      "branch": "",
                      "highBalance": "24999",
                      "dateOpened": "2023-02-14+05:30",
                      "dateReported": "2023-10-31+05:30",
                      "accountsSoldTo": "",
                      "bureau": "",
                      "writtenOffAmtTotal": "-1",
                      "PayStatus": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "currentBalance": "0",
                      "subscriberCode": "66030001",
                      "AccountDesignator": {
                        "symbol": "1",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "dateAccountStatus": "2023-08-02+05:30",
                      "accountNumber": "4O7RDDJE879689",
                      "AccountCondition": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "Source": {
                        "Reference": "f9aaa11a-8716-43e5-9774-83d951ad8d1e",
                        "InquiryDate": "2026-08-29+05:30",
                        "Locale": "en_IN",
                        "BorrowerKey": "1841954230",
                        "Bureau": {
                          "symbol": "CIBIL",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        }
                      },
                      "IndustryCode": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "thirdPartyName": "",
                      "GrantedTrade": {
                        "interestRate": "-1.00",
                        "PaymentFrequency": {
                          "symbol": "03",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "serialNumber": "2417435137",
                        "PayStatusHistory": {
                          "endDate": "2023-02-01+05:30",
                          "startDate": "2023-10-01+05:30",
                          "MonthlyPayStatus": [
                            {
                              "date": "2023-10-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2023-09-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2023-08-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2023-07-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2023-06-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2023-05-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2023-04-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2023-03-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2023-02-01+05:30",
                              "status": "0"
                            }
                          ],
                          "status": "0,0,0,0,0,0,0,0,0,"
                        },
                        "EMIAmount": "3125",
                        "WorstPayStatus": {
                          "symbol": "",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "CashLimit": "-1",
                        "dateLastPayment": "2023-08-02+05:30",
                        "AccountType": {
                          "symbol": "06",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "CreditType": {
                          "symbol": "06",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "actualPaymentAmount": "-1",
                        "termMonths": "8",
                        "CreditLimit": "-1",
                        "CollateralType": {
                          "symbol": "",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "amountPastDue": "0",
                        "collateral": "-1",
                        "TermType": {
                          "symbol": "",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        }
                      },
                      "VerificationIndicator": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "noOfParticipants": "",
                      "OpenClosed": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "position": "7",
                      "settlementAmount": "-1",
                      "writtenOffPrincipal": "-1"
                    }
                  },
                  {
                    "accountTypeAbbreviation": "",
                    "accountTypeDescription": "",
                    "accountTypeSymbol": "05",
                    "Tradeline": {
                      "DisputeFlag": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "creditorName": "HERO FINCORP",
                      "branch": "",
                      "highBalance": "151540",
                      "dateOpened": "2023-01-12+05:30",
                      "dateReported": "2026-08-09+05:30",
                      "accountsSoldTo": "",
                      "bureau": "",
                      "writtenOffAmtTotal": "-1",
                      "PayStatus": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "currentBalance": "23880",
                      "subscriberCode": "69900001",
                      "AccountDesignator": {
                        "symbol": "1",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "dateAccountStatus": "2026-08-08+05:30",
                      "accountNumber": "BRSLPL00100011685451",
                      "AccountCondition": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "Source": {
                        "Reference": "f9aaa11a-8716-43e5-9774-83d951ad8d1e",
                        "InquiryDate": "2026-08-29+05:30",
                        "Locale": "en_IN",
                        "BorrowerKey": "1841954230",
                        "Bureau": {
                          "symbol": "CIBIL",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        }
                      },
                      "IndustryCode": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "thirdPartyName": "",
                      "GrantedTrade": {
                        "interestRate": "25.93",
                        "PaymentFrequency": {
                          "symbol": "03",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "serialNumber": "2360396728",
                        "PayStatusHistory": {
                          "endDate": "2023-09-01+05:30",
                          "startDate": "2026-08-01+05:30",
                          "MonthlyPayStatus": [
                            {
                              "date": "2026-08-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2026-07-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2026-06-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2026-05-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2026-04-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2026-03-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2026-02-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2026-01-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2025-12-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2025-11-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2025-10-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2025-09-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2025-08-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2025-07-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2025-06-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2025-05-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2025-04-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2025-03-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2025-02-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2025-01-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-12-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-11-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-10-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-09-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-08-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-07-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-06-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-05-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-04-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-03-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-02-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-01-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2023-12-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2023-11-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2023-10-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2023-09-01+05:30",
                              "status": "0"
                            }
                          ],
                          "status": "0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,"
                        },
                        "EMIAmount": "5096",
                        "WorstPayStatus": {
                          "symbol": "",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "CashLimit": "-1",
                        "dateLastPayment": "2026-08-08+05:30",
                        "AccountType": {
                          "symbol": "05",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "CreditType": {
                          "symbol": "05",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "actualPaymentAmount": "214082",
                        "termMonths": "48",
                        "CreditLimit": "-1",
                        "CollateralType": {
                          "symbol": "",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "amountPastDue": "0",
                        "collateral": "-1",
                        "TermType": {
                          "symbol": "",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        }
                      },
                      "VerificationIndicator": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "noOfParticipants": "",
                      "OpenClosed": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "position": "8",
                      "settlementAmount": "-1",
                      "writtenOffPrincipal": "-1"
                    }
                  },
                  {
                    "accountTypeAbbreviation": "",
                    "accountTypeDescription": "",
                    "accountTypeSymbol": "13",
                    "Tradeline": {
                      "DisputeFlag": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "creditorName": "HERO FINCORP",
                      "dateClosed": "2022-12-15+05:30",
                      "branch": "",
                      "highBalance": "45319",
                      "dateOpened": "2021-05-29+05:30",
                      "dateReported": "2022-12-31+05:30",
                      "accountsSoldTo": "",
                      "bureau": "",
                      "writtenOffAmtTotal": "-1",
                      "PayStatus": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "currentBalance": "0",
                      "subscriberCode": "69900001",
                      "AccountDesignator": {
                        "symbol": "1",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "dateAccountStatus": "2022-12-08+05:30",
                      "accountNumber": "BRSTWL00100006764335",
                      "AccountCondition": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "Source": {
                        "Reference": "f9aaa11a-8716-43e5-9774-83d951ad8d1e",
                        "InquiryDate": "2026-08-29+05:30",
                        "Locale": "en_IN",
                        "BorrowerKey": "1841954230",
                        "Bureau": {
                          "symbol": "CIBIL",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        }
                      },
                      "IndustryCode": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "thirdPartyName": "",
                      "GrantedTrade": {
                        "interestRate": "21.76",
                        "PaymentFrequency": {
                          "symbol": "03",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "serialNumber": "1719091015",
                        "PayStatusHistory": {
                          "endDate": "2021-05-01+05:30",
                          "startDate": "2022-12-01+05:30",
                          "MonthlyPayStatus": [
                            {
                              "date": "2022-12-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2022-11-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2022-10-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2022-09-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2022-08-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2022-07-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2022-06-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2022-05-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2022-04-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2022-03-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2022-02-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2022-01-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2021-12-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2021-11-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2021-10-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2021-09-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2021-08-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2021-07-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2021-06-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2021-05-01+05:30",
                              "status": "0"
                            }
                          ],
                          "status": "0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,"
                        },
                        "EMIAmount": "2990",
                        "WorstPayStatus": {
                          "symbol": "",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "CashLimit": "-1",
                        "dateLastPayment": "2022-12-08+05:30",
                        "AccountType": {
                          "symbol": "13",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "CreditType": {
                          "symbol": "13",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "actualPaymentAmount": "54194",
                        "termMonths": "18",
                        "CreditLimit": "-1",
                        "CollateralType": {
                          "symbol": "",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "amountPastDue": "0",
                        "collateral": "-1",
                        "TermType": {
                          "symbol": "",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        }
                      },
                      "VerificationIndicator": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "noOfParticipants": "",
                      "OpenClosed": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "position": "9",
                      "settlementAmount": "-1",
                      "writtenOffPrincipal": "-1"
                    }
                  },
                  {
                    "accountTypeAbbreviation": "",
                    "accountTypeDescription": "",
                    "accountTypeSymbol": "06",
                    "Tradeline": {
                      "DisputeFlag": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "creditorName": "BAJAJ FIN LTD",
                      "dateClosed": "2019-08-11+05:30",
                      "branch": "",
                      "highBalance": "19200",
                      "dateOpened": "2018-08-29+05:30",
                      "dateReported": "2021-03-31+05:30",
                      "accountsSoldTo": "",
                      "bureau": "",
                      "writtenOffAmtTotal": "-1",
                      "PayStatus": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "currentBalance": "0",
                      "subscriberCode": "66030001",
                      "AccountDesignator": {
                        "symbol": "1",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "dateAccountStatus": "2019-05-05+05:30",
                      "accountNumber": "4O7RDP86074326",
                      "AccountCondition": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "Source": {
                        "Reference": "f9aaa11a-8716-43e5-9774-83d951ad8d1e",
                        "InquiryDate": "2026-08-29+05:30",
                        "Locale": "en_IN",
                        "BorrowerKey": "1841954230",
                        "Bureau": {
                          "symbol": "CIBIL",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        }
                      },
                      "IndustryCode": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "thirdPartyName": "",
                      "GrantedTrade": {
                        "interestRate": "-1.00",
                        "PaymentFrequency": {
                          "symbol": "",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "serialNumber": "1089075864",
                        "PayStatusHistory": {
                          "endDate": "2018-08-01+05:30",
                          "startDate": "2021-03-01+05:30",
                          "MonthlyPayStatus": [
                            {
                              "date": "2021-03-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2021-02-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2021-01-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2020-12-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2020-11-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2020-10-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2020-09-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2020-08-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2020-07-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2020-06-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2020-05-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2020-04-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2020-03-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2020-02-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2020-01-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2019-12-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2019-11-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2019-10-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2019-09-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2019-08-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2019-07-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2019-06-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2019-05-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2019-04-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2019-03-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2019-02-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2019-01-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2018-12-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2018-11-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2018-10-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2018-09-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2018-08-01+05:30",
                              "status": "0"
                            }
                          ],
                          "status": "0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,"
                        },
                        "EMIAmount": "-1",
                        "WorstPayStatus": {
                          "symbol": "",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "CashLimit": "-1",
                        "dateLastPayment": "2019-05-05+05:30",
                        "AccountType": {
                          "symbol": "06",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "CreditType": {
                          "symbol": "06",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "actualPaymentAmount": "-1",
                        "termMonths": "-1",
                        "CreditLimit": "-1",
                        "CollateralType": {
                          "symbol": "",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "amountPastDue": "0",
                        "collateral": "-1",
                        "TermType": {
                          "symbol": "",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        }
                      },
                      "VerificationIndicator": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "noOfParticipants": "",
                      "OpenClosed": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "position": "10",
                      "settlementAmount": "-1",
                      "writtenOffPrincipal": "-1"
                    }
                  },
                  {
                    "accountTypeAbbreviation": "",
                    "accountTypeDescription": "",
                    "accountTypeSymbol": "01",
                    "Tradeline": {
                      "DisputeFlag": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "creditorName": "BOI",
                      "dateClosed": "2024-08-28+05:30",
                      "branch": "",
                      "highBalance": "655000",
                      "dateOpened": "2017-10-17+05:30",
                      "dateReported": "2024-08-31+05:30",
                      "accountsSoldTo": "",
                      "bureau": "",
                      "writtenOffAmtTotal": "-1",
                      "PayStatus": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "currentBalance": "0",
                      "subscriberCode": "1040001",
                      "AccountDesignator": {
                        "symbol": "3",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "dateAccountStatus": "2024-06-28+05:30",
                      "accountNumber": "072960510000024",
                      "AccountCondition": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "Source": {
                        "Reference": "f9aaa11a-8716-43e5-9774-83d951ad8d1e",
                        "InquiryDate": "2026-08-29+05:30",
                        "Locale": "en_IN",
                        "BorrowerKey": "1841954230",
                        "Bureau": {
                          "symbol": "CIBIL",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        }
                      },
                      "IndustryCode": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "thirdPartyName": "",
                      "GrantedTrade": {
                        "interestRate": "9.30",
                        "PaymentFrequency": {
                          "symbol": "03",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "serialNumber": "1170597745",
                        "PayStatusHistory": {
                          "endDate": "2021-09-01+05:30",
                          "startDate": "2024-08-01+05:30",
                          "MonthlyPayStatus": [
                            {
                              "date": "2024-08-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-07-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-06-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-05-01+05:30",
                              "status": "11"
                            },
                            {
                              "date": "2024-04-01+05:30",
                              "status": "0"
                            },
                            {
                              "date": "2024-03-01+05:30",
                              "status": "62"
                            },
                            {
                              "date": "2024-02-01+05:30",
                              "status": "31"
                            },
                            {
                              "date": "2024-01-01+05:30",
                              "status": "63"
                            },
                            {
                              "date": "2023-12-01+05:30",
                              "status": "32"
                            },
                            {
                              "date": "2023-11-01+05:30",
                              "status": "1"
                            },
                            {
                              "date": "2023-10-01+05:30",
                              "status": "63"
                            },
                            {
                              "date": "2023-09-01+05:30",
                              "status": "32"
                            },
                            {
                              "date": "2023-08-01+05:30",
                              "status": "2"
                            },
                            {
                              "date": "2023-07-01+05:30",
                              "status": "32"
                            },
                            {
                              "date": "2023-06-01+05:30",
                              "status": "62"
                            },
                            {
                              "date": "2023-05-01+05:30",
                              "status": "32"
                            },
                            {
                              "date": "2023-04-01+05:30",
                              "status": "1"
                            },
                            {
                              "date": "2023-03-01+05:30",
                              "status": "STD"
                            },
                            {
                              "date": "2023-02-01+05:30",
                              "status": "STD"
                            },
                            {
                              "date": "2023-01-01+05:30",
                              "status": "STD"
                            },
                            {
                              "date": "2022-12-01+05:30",
                              "status": "STD"
                            },
                            {
                              "date": "2022-11-01+05:30",
                              "status": "STD"
                            },
                            {
                              "date": "2022-10-01+05:30",
                              "status": "STD"
                            },
                            {
                              "date": "2022-09-01+05:30",
                              "status": "STD"
                            },
                            {
                              "date": "2022-08-01+05:30",
                              "status": "STD"
                            },
                            {
                              "date": "2022-07-01+05:30",
                              "status": "STD"
                            },
                            {
                              "date": "2022-06-01+05:30",
                              "status": "STD"
                            },
                            {
                              "date": "2022-05-01+05:30",
                              "status": "STD"
                            },
                            {
                              "date": "2022-04-01+05:30",
                              "status": "STD"
                            },
                            {
                              "date": "2022-03-01+05:30",
                              "status": "STD"
                            },
                            {
                              "date": "2022-02-01+05:30",
                              "status": "STD"
                            },
                            {
                              "date": "2022-01-01+05:30",
                              "status": "STD"
                            },
                            {
                              "date": "2021-12-01+05:30",
                              "status": "STD"
                            },
                            {
                              "date": "2021-11-01+05:30",
                              "status": "STD"
                            },
                            {
                              "date": "2021-10-01+05:30",
                              "status": "STD"
                            },
                            {
                              "date": "2021-09-01+05:30",
                              "status": "STD"
                            }
                          ],
                          "status": "0,0,0,11,0,62,31,63,32,1,63,32,2,32,62,32,1,STD,STD,STD,STD,STD,STD,STD,STD,STD,STD,STD,STD,STD,STD,STD,STD,STD,STD,STD,"
                        },
                        "EMIAmount": "4878",
                        "WorstPayStatus": {
                          "symbol": "",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "CashLimit": "-1",
                        "dateLastPayment": "2024-06-28+05:30",
                        "AccountType": {
                          "symbol": "01",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "CreditType": {
                          "symbol": "01",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "actualPaymentAmount": "-1",
                        "termMonths": "88",
                        "CreditLimit": "-1",
                        "CollateralType": {
                          "symbol": "01",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        },
                        "amountPastDue": "0",
                        "collateral": "0",
                        "TermType": {
                          "symbol": "",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        }
                      },
                      "VerificationIndicator": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "noOfParticipants": "",
                      "OpenClosed": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "position": "11",
                      "settlementAmount": "-1",
                      "writtenOffPrincipal": "-1"
                    }
                  }
                ],
                "InquiryPartition": [
                  {
                    "Inquiry": {
                      "amount": "150000",
                      "IndustryCode": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "inquiryType": "05",
                      "subscriberName": "BAJAJ FIN LTD",
                      "enqControlNum": "11385913267",
                      "description": "",
                      "subscriberNumber": "",
                      "bureau": "",
                      "Source": {
                        "Reference": "f9aaa11a-8716-43e5-9774-83d951ad8d1e",
                        "InquiryDate": "2026-08-29+05:30",
                        "Locale": "en_IN",
                        "BorrowerKey": "1841954230",
                        "Bureau": {
                          "symbol": "CIBIL",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        }
                      },
                      "inquiryDate": "2026-07-30+05:30"
                    }
                  },
                  {
                    "Inquiry": {
                      "amount": "150000",
                      "IndustryCode": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "inquiryType": "05",
                      "subscriberName": "BAJAJ FIN LTD",
                      "enqControlNum": "11385801758",
                      "description": "",
                      "subscriberNumber": "",
                      "bureau": "",
                      "Source": {
                        "Reference": "f9aaa11a-8716-43e5-9774-83d951ad8d1e",
                        "InquiryDate": "2026-08-29+05:30",
                        "Locale": "en_IN",
                        "BorrowerKey": "1841954230",
                        "Bureau": {
                          "symbol": "CIBIL",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        }
                      },
                      "inquiryDate": "2026-07-30+05:30"
                    }
                  },
                  {
                    "Inquiry": {
                      "amount": "5000000",
                      "IndustryCode": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "inquiryType": "54",
                      "subscriberName": "VIDYABANK",
                      "enqControlNum": "10846932748",
                      "description": "",
                      "subscriberNumber": "",
                      "bureau": "",
                      "Source": {
                        "Reference": "f9aaa11a-8716-43e5-9774-83d951ad8d1e",
                        "InquiryDate": "2026-08-29+05:30",
                        "Locale": "en_IN",
                        "BorrowerKey": "1841954230",
                        "Bureau": {
                          "symbol": "CIBIL",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        }
                      },
                      "inquiryDate": "2026-04-15+05:30"
                    }
                  },
                  {
                    "Inquiry": {
                      "amount": "150000",
                      "IndustryCode": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "inquiryType": "05",
                      "subscriberName": "BAJAJ FIN LTD",
                      "enqControlNum": "10721253652",
                      "description": "",
                      "subscriberNumber": "",
                      "bureau": "",
                      "Source": {
                        "Reference": "f9aaa11a-8716-43e5-9774-83d951ad8d1e",
                        "InquiryDate": "2026-08-29+05:30",
                        "Locale": "en_IN",
                        "BorrowerKey": "1841954230",
                        "Bureau": {
                          "symbol": "CIBIL",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        }
                      },
                      "inquiryDate": "2026-03-21+05:30"
                    }
                  },
                  {
                    "Inquiry": {
                      "amount": "6000000",
                      "IndustryCode": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "inquiryType": "50",
                      "subscriberName": "VIDYABANK",
                      "enqControlNum": "9250600127",
                      "description": "",
                      "subscriberNumber": "",
                      "bureau": "",
                      "Source": {
                        "Reference": "f9aaa11a-8716-43e5-9774-83d951ad8d1e",
                        "InquiryDate": "2026-08-29+05:30",
                        "Locale": "en_IN",
                        "BorrowerKey": "1841954230",
                        "Bureau": {
                          "symbol": "CIBIL",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        }
                      },
                      "inquiryDate": "2025-06-25+05:30"
                    }
                  },
                  {
                    "Inquiry": {
                      "amount": "10",
                      "IndustryCode": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "inquiryType": "53",
                      "subscriberName": "HDFC BANK",
                      "enqControlNum": "7781636074",
                      "description": "",
                      "subscriberNumber": "",
                      "bureau": "",
                      "Source": {
                        "Reference": "f9aaa11a-8716-43e5-9774-83d951ad8d1e",
                        "InquiryDate": "2026-08-29+05:30",
                        "Locale": "en_IN",
                        "BorrowerKey": "1841954230",
                        "Bureau": {
                          "symbol": "CIBIL",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        }
                      },
                      "inquiryDate": "2024-07-04+05:30"
                    }
                  },
                  {
                    "Inquiry": {
                      "amount": "224000",
                      "IndustryCode": {
                        "symbol": "",
                        "description": "",
                        "rank": "100000",
                        "abbreviation": ""
                      },
                      "inquiryType": "34",
                      "subscriberName": "KOTAK BANK",
                      "enqControlNum": "7184154804",
                      "description": "",
                      "subscriberNumber": "",
                      "bureau": "",
                      "Source": {
                        "Reference": "f9aaa11a-8716-43e5-9774-83d951ad8d1e",
                        "InquiryDate": "2026-08-29+05:30",
                        "Locale": "en_IN",
                        "BorrowerKey": "1841954230",
                        "Bureau": {
                          "symbol": "CIBIL",
                          "description": "",
                          "rank": "100000",
                          "abbreviation": ""
                        }
                      },
                      "inquiryDate": "2024-02-17+05:30"
                    }
                  }
                ]
              },
              "AssetId": "30715846867",
              "Type": "SingleCreditReport"
            }
          }
        }
      }
    },
    {
      "step": 4,
      "name": "GetProductWebToken",
      "status": "success",
      "http_code": 200,
      "response": {
        "GetProductWebTokenResponse": {
          "ResponseKey": "ec3f861cf9e9a2e0:-2d58d8ee:1a04be7df79:4861",
          "ResponseStatus": "Success",
          "GetProductWebTokenSuccess": {
            "PartnerCustomerId": "J92AQFLNIMWBG2HCBRBA",
            "WebToken": "6WyeN-Vuf3QwNTc8apPfaQCaOsOQE4QeRzijqzupOd453FGPerRdEFxOiS_4sq5J37XZ1XkFBjHucNYRijqDGCypXw5kWhssi356tUzjItU"
          }
        }
      }
    }
  ],
  "transunion_webtoken_url": "https://myscore.cibil.com/CreditView/webtokenasset.page?enterprise=UYFincorp&pcc=J92AQFLNIMWBG2HCBRBA&webtoken=6WyeN-Vuf3QwNTc8apPfaQCaOsOQE4QeRzijqzupOd453FGPerRdEFxOiS_4sq5J37XZ1XkFBjHucNYRijqDGCypXw5kWhssi356tUzjItU",
  "transunion_json_report_url": "https://my-credit-analytics-bucket-xaler.s3.amazonaws.com/TransUnion-json/transunion_cibil_11546884092.json?AWSAccessKeyId=AKIA3FLD3UWVR3KVDQVK&Signature=eFyA61YawnjrlzRYztiOsURkDDQ%3D&Expires=1788586206",
  "xaler_generated_pdf_report_url": null,
  "web_token_url": "https://myscore.cibil.com/CreditView/webtokenasset.page?enterprise=UYFincorp&pcc=J92AQFLNIMWBG2HCBRBA&webtoken=6WyeN-Vuf3QwNTc8apPfaQCaOsOQE4QeRzijqzupOd453FGPerRdEFxOiS_4sq5J37XZ1XkFBjHucNYRijqDGCypXw5kWhssi356tUzjItU",
  "report_url": "https://my-credit-analytics-bucket-xaler.s3.amazonaws.com/TransUnion-json/transunion_cibil_11546884092.json?AWSAccessKeyId=AKIA3FLD3UWVR3KVDQVK&Signature=eFyA61YawnjrlzRYztiOsURkDDQ%3D&Expires=1788586206",
  "pdf_report_url": null
}
  
});
  const endPoint = "/srv5/transunion-Score-Hybrid";
  const [serviceName, setServiceName] = useState("");

  const [firstName, setFirstName] = useState("");
  const [dob, setDob] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobile, setMobile] = useState("");
  const [gender, setGender] = useState("");
  const [pan, setPan] = useState("");
  const [inputError, setInputError] = useState(null);

  const [profileData, setProfileData] = useState(null);
  const [score, setScore] = useState(response);
  let apiResponse;

  const handleReport = async () => {
    if (!profileData) return;

    if (!lastName || !firstName || !gender || !mobile || !pan) {
      return setInputError(
        "firstName, lastName, gender, mobile, pan fields are Required",
      );
    }

    if (mobile && mobile?.length < 10) {
      return setInputError("⚠️ Please enter 10 digits in Mobile No. field");
    }

    try {
      setInputError(null);
      setIsLoading(true);
      setResponse(null);

      const res = await checkTransUnionReportHybrid({
        api_id: profileData.user_id,
        api_key: profileData.api_key,
        token_id: profileData.token_id,
        forename: firstName.trim(),
        surname: lastName.trim(),
        gender,
        dob,
        pan_id: pan,
        phone_number: mobile,
      });

      if (res) {
        apiResponse = res;
        console.log(res);
      }
      setResponse(apiResponse);

      if (res?.status?.code === 200) {
        showSuccessToast(res?.message || "Success");
      } else {
        // showErrorToast(res?.data?.message || "invalid details ");
        const err = res?.error || res?.data?.errors;

        const errMsg = Object.values(err || {});

        errMsg?.map((item, idx) => showErrorToast(item[0]));

        console.log("error message", res.data?.error);

        showErrorToast(
          res.data?.error ||
            res?.data?.message ||
            res?.message ||
            res?.data?.data?.message ||
            "Validation Failed",
        );
      }
    } catch (error) {
      console.error(error);
      showErrorToast("Server error");
    } finally {
      setIsLoading(false);
    }
  };

  // ---------------- FETCH PROFILE ----------------
  useEffect(() => {
    const loadProfile = async () => {
      try {
        setIsLoading(true);
        const res = await fetchProfile();
        setProfileData(res?.data || null);
      } catch (error) {
        console.error(error);
        showErrorToast("Failed to fetch profile");
      } finally {
        setIsLoading(false);
      }
    };

    loadProfile();
  }, []);

  useEffect(() => {
    const getServiceName = async () => {
      try {
        const res = await getServiceNameAndDetails({
          end_point: endPoint,
        });

        if (res?.status?.code === 200) {
          setServiceName(res?.data?.service_name);
        }
      } catch (error) {
        console.log(error);
      }
    };

    getServiceName();
  }, []);

  return (
    <>
      <Seo />
      <Header heading={serviceName} />

      {isLoading && (
        <div className="flex justify-center mt-6">
          <Loader className="animate-spin" />
        </div>
      )}

      <div className="w-full min-h-screen flex flex-col items-center justify-start pb-14">
        {/* ---------------- FORM ---------------- */}
        <div className=" w-full mt-2 rounded-2xl border border-slate-200 bg-white px-6 py-2 shadow-xl shadow-slate-100">
          {/* Header */}
          <div className="flex items-center gap-3 border-b border-slate-100 pb-5">
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-blue-100 text-blue-600">
              <Gauge size={24} />
            </div>

            <div>
              <h2 className="text-xl font-bold text-slate-800">
                Transunion Hybrid Report
              </h2>
              <p className="text-sm text-slate-500">
                Get Transunion Report using Name, mobile, pan and gender.
              </p>
            </div>
          </div>

          {/* Inputs */}
          <div className="mt-6 grid grid-cols-1 gap-6 md:grid-cols-3 xl:grid-cols-5">
            <div>
              <label className="mb-2 flex items-center gap-2 text-sm font-semibold text-slate-700">
                <ShieldCheck size={17} className="text-blue-600" />
                First Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                placeholder="Eg: Abhishek"
                className="w-full rounded-xl border uppercase border-slate-300 px-4 py-2 text-sm transition-all duration-200 placeholder:text-slate-400 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 outline-none"
              />
            </div>

            <div>
              <label className="mb-2 flex items-center gap-2 text-sm font-semibold text-slate-700">
                <ShieldCheck size={17} className="text-blue-600" />
                Last Name <span className="text-red-500">*</span>
              </label>

              <input
                type="text"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                placeholder="Eg: Kumar"
                className="w-full rounded-xl border uppercase border-slate-300 px-4 py-2 text-sm transition-all duration-200 placeholder:text-slate-400 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 outline-none"
              />
            </div>
            <div>
              <label className="mb-2 flex items-center gap-2 text-sm font-semibold text-slate-700">
                <ShieldCheck size={17} className="text-blue-600" />
                Mobile <span className="text-red-500">*</span>
              </label>

              <input
                type="number"
                value={mobile}
                maxLength={10}
                onChange={(e) => setMobile(e.target.value)}
                placeholder="Eg: 9699869587"
                className="w-full rounded-xl border border-slate-300 px-4 py-2 text-sm transition-all duration-200 placeholder:text-slate-400 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 outline-none"
              />
            </div>
            <div>
              <label className="mb-2 flex items-center gap-2 text-sm font-semibold text-slate-700">
                <ShieldCheck size={17} className="text-blue-600" />
                PAN <span className="text-red-500">*</span>
              </label>

              <input
                type="text"
                value={pan}
                maxLength={10}
                onChange={(e) => setPan(e.target.value)}
                placeholder="Eg: BTUPJ4358H"
                className="w-full rounded-xl border uppercase border-slate-300 px-4 py-2 text-sm transition-all duration-200 placeholder:text-slate-400 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 outline-none"
              />
            </div>
            <div>
              <label className="mb-2 flex items-center gap-2 text-sm font-semibold text-slate-700">
                <ShieldCheck size={17} className="text-blue-600" />
                Gender <span className="text-red-500">*</span>
              </label>

              <select
                onChange={(e) => setGender(e.target.value)}
                className="w-full rounded-xl border uppercase border-slate-300 px-4 py-2 text-sm transition-all duration-200 placeholder:text-slate-400 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 outline-none"
                name="gender"
                id="gender"
              >
                <option value="">Select</option>
                <option value="Male">MALE</option>
                <option value="Female">FEMALE</option>
              </select>
            </div>
            <div>
              <label className="mb-2 flex items-center gap-2 text-sm font-semibold text-slate-700">
                <ShieldCheck size={17} className="text-blue-600" />
                Date Of Birth (Optional)
              </label>

              <input
                type="date"
                value={dob}
                maxLength={10}
                onChange={(e) => setDob(e.target.value)}
                className="w-full rounded-xl border uppercase border-slate-300 px-4 py-2 text-sm transition-all duration-200 placeholder:text-slate-400 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 outline-none"
              />
            </div>
          </div>
          <DeepIndigoNotice />

          {/* Error */}
          {inputError && (
            <div className="mt-5 flex items-center gap-3 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-red-700">
              <AlertCircle size={18} />
              <span className="text-sm font-medium">{inputError}</span>
            </div>
          )}

          {/* Button */}
          <div className="mt-8 flex justify-end">
            <button
              disabled={
                isLoading ||
                !lastName ||
                !firstName ||
                !mobile ||
                !gender ||
                !pan
              }
              onClick={handleReport}
              className="group inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-blue-600 to-indigo-600 px-7 py-3 font-semibold text-white shadow-md transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg disabled:cursor-not-allowed disabled:opacity-50"
            >
              {isLoading ? (
                <>
                  <Cog size={18} className="animate-spin" />
                  Verifying...
                </>
              ) : (
                <>
                  Get Report
                  <ArrowRight
                    size={18}
                    className="transition-transform duration-300 group-hover:translate-x-1"
                  />
                </>
              )}
            </button>
          </div>
        </div>

        {/* ---------------- RESULT ---------------- */}
        {response?.status?.code === 200 && (
          <SummaryScore responseData={response} />
        )}
      </div>
    </>
  );
}

export default TransunionHybrid;

function DeepIndigoNotice() {
  return (
    <div className="relative mt-2 overflow-hidden rounded-2xl bg-gradient-to-r from-indigo-700 via-blue-600 to-violet-700 p-0.5 shadow-xl shadow-indigo-500/20">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 rounded-[15px]  p-1 sm:p-2 backdrop-blur-xl text-white">
        <div className="flex items-center gap-3.5">
          {/* Glowing Icon Badge */}
          <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-indigo-500 to-blue-600 text-white shadow-md shadow-indigo-500/40 ring-1 ring-white/20">
            <ShieldCheck className="h-6 w-6" />
          </div>

          <div>
            {/* <div className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-amber-400">
              <Sparkles className="h-3.5 w-3.5" />
              High-Precision Report
            </div> */}
            <p className="text-sm sm:text-base font-semibold text-slate-100 mt-0.5">
              Complete all required fields Above to generate a{" "}
              <span className="font-bold text-amber-300 underline decoration-amber-400/50 underline-offset-4">
                100% accurate report
              </span>
              .
            </p>
          </div>
        </div>

        <div className="shrink-0 rounded-xl bg-amber-400/10 px-3.5 py-1.5 text-xs font-bold text-amber-300 ring-1 ring-amber-400/30 flex items-center gap-1.5">
          <FileCheck className="h-4 w-4" />
          Precision Processing
        </div>
      </div>
    </div>
  );
}
